export default {
    set_events(state, events) {
      state.events = events;
    },
    set_weekPlan(state, weekPlan){
      state.weekPlan = weekPlan
    },
    set_order(state, order){
      state.order = order
    },
    set_reservation(state, reservations){
      state.reservations = reservations
    },
    set_open_reservation(state, reservations){
      state.open_reservation=reservations
    }
  };
  